/*
 * @Author: chenmin
 * @version: 1.0.0
 * @Date: 2022-10-31 10:21:15
 * @LastEditTime: 2022-11-07 11:36:24
 * @Description: 通用层级管理api
 */

const API = `/api/v1`
export const COMMON_ONE_GET = `${API}/basic/manager/reResourceTypes`;
export const COMMON_ONE_SET = `${API}/basic/manager/reResourceType`;
export const COMMON_ONE_DEAL = `${API}/basic/manager/reResourceType/{id}/update/status/{used}`;

export const COMMON_TWO_GET = `${API}/basic/manager/reColumns`;
export const COMMON_TWO_SET = `${API}/basic/manager/reColumn`;
export const COMMON_TWO_DEAL = `${API}/basic/manager/reColumn/{id}/update/status/{used}`;

export const COMMON_THREE_GET = `${API}/basic/manager/reBasicDetailTypes`;
export const COMMON_THREE_SET = `${API}/basic/manager/reBasicDetailType`;
export const COMMON_THREE_DEAL = `${API}/basic/manager/reBasicDetailType/{id}/update/status/{used}`;



// WEBPACK FOOTER //
// ./src/resource/common.js